<template>
  <v-row>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col cols="12" class="pt-5 pr-6">
            <v-btn color="primary" dark small class="float-end" v-bind="attrs" v-on="on">
                 {{ $t("btn.UploadAbout") }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t("btn.UploadAbout") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-file-input show-size counter label="รูปภาพ 1,950 x 1,080" required :rules="FileRules" accept="image/png, image/jpeg, image/bmp" prepend-icon="mdi-camera" v-model="FileImg"></v-file-input>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false" :loading="$store.getters.overlay">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="SaveClick" :loading="$store.getters.overlay">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialogComplete" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          บันทึกข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="ClickComplete">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  export default {
    data: () => ({
      dialog: false,
      FileImg:null,
      valid:false,
      dialogComplete:false,
      data:null,
      FileRules: [
        v => !!v || 'File is required'
      ],
      req:{},
    }),
    methods: {
      
      SaveClick() {
        if(this.$refs.form.validate()){
          this.$store.commit('set_overlay',true);
          let formData = new FormData();
          formData.append('FileImg',this.FileImg,this.FileImg.name);
          formData.append('locale',this.$store.getters.authen.locale);
          this.req.post(this.$store.getters.base_api + 'post-upload-background-ceo',formData,{ headers: {'Content-Type': 'multipart/form-data'},})
                .then(response=>{
                  this.dialog = false;
                  this.dialogComplete = true;
                  this.$emit('complete',response.data.data);
                  this.$store.commit('set_overlay',false);
               }).catch(error => {
                  this.$store.commit('set_overlay',true);
              });
        }
      },
      ClickComplete(){
        this.dialogComplete = false;
        
      },
    },
    mounted() {
      this.req = this.$store.getters.req;
      
    },
  }
</script>